import {Presenter} from '../../../../../../Support/with_presenter';
import {Crew} from '../../../../../../Models/Crew';
import {WorkoutsService} from '../../../../../../Network/WorkoutsService';
import {PartialWorkout} from '../../../../../../Models/PartialWorkout';
import {addMonths, addWeeks, endOfMonth, endOfWeek, startOfMonth, startOfWeek, subMonths} from 'date-fns';
import {loadingResponse, NetworkRequestStatus, NetworkResult} from '../../../../../../Network/NetworkResult';

export class CrewActivitiesPresenter implements Presenter {
    public referenceDate = new Date();

    public workouts: NetworkResult<PartialWorkout[]> = loadingResponse();

    public get weeks(): Array<{
        startAt: Date;
        endAt: Date;
        workouts: PartialWorkout[];
    }> {
        let referenceDate = startOfWeek(startOfMonth(this.referenceDate));
        const weeks = [];
        do {
            const endAt = endOfWeek(referenceDate);
            weeks.push({
                startAt: referenceDate,
                endAt: endAt,
                workouts:
                    this.workouts.status === NetworkRequestStatus.Success
                        ? this.workouts.data.filter((workout) => {
                              return workout.executed_at >= referenceDate && workout.executed_at <= endAt;
                          })
                        : [],
            });

            referenceDate = addWeeks(referenceDate, 1);
        } while (referenceDate < endOfMonth(this.referenceDate));

        return weeks;
    }

    constructor(private crew: Crew, private workoutService: WorkoutsService) {}

    public async mount(): Promise<void> {
        await this.fetch();
    }

    private async fetch() {
        this.workouts = loadingResponse();
        this.workouts = await this.workoutService.forCrew(
            this.crew.id,
            startOfMonth(this.referenceDate),
            endOfMonth(this.referenceDate),
        );
    }

    public unmount(): void {
        /* Noop */
    }

    public async navigateToday() {
        this.referenceDate = new Date();
        await this.fetch();
    }

    public async navigateBack() {
        this.referenceDate = subMonths(this.referenceDate, 1);
        await this.fetch();
    }

    public async navigateForward() {
        this.referenceDate = addMonths(this.referenceDate, 1);
        await this.fetch();
    }
}
